<div class="outer-div">
  <fs-snap-ai-selector [snapAiImage]="data"></fs-snap-ai-selector>
</div>
